/**
 * Rows a view needs LIVE by ticker, beyond what its board scope streams — the
 * feed gateway's `tickers` scope facet (relay/src/feedgw/scopes.ts).
 *
 * Why a registry of its own (2026-09-23): the gateway HOLDS every Polymarket
 * alternate spread/total line on a lines board but streams none of them —
 * measured on node1, they were ~80% of ~700 market frames/s and a trader's
 * tab fell seconds behind. The line the board shows per game rides the books
 * scope; the lines of the game a trader has EXPANDED are named here. The
 * feedNeeds union cannot carry this: a ticker-scoped source next to the broad
 * dashboard folds to "broad" (that is its contract on the fleet wire), and the
 * fleet path streams these rows regardless, so only the gateway reads this.
 *
 * Outside React/Zustand on purpose, like boardKinds — a declaration change
 * must never re-render anything.
 */
export type RowNeedsSink = (tickers: string[]) => void;

const _sources = new Map<string, readonly string[]>();
let _sink: RowNeedsSink | null = null;

export function currentRowNeeds(): string[] {
  const out = new Set<string>();
  for (const tickers of _sources.values()) for (const t of tickers) if (t) out.add(t);
  return [...out].sort();
}

/** Declare (or clear, with `null` / an empty list) one source's live rows. */
export function declareRowNeeds(sourceId: string, tickers: readonly string[] | null): void {
  if (tickers == null || tickers.length === 0) {
    if (!_sources.delete(sourceId)) return;
  } else {
    const prev = _sources.get(sourceId);
    if (prev && prev.length === tickers.length && prev.every((t, i) => t === tickers[i])) return;
    _sources.set(sourceId, [...tickers]);
  }
  _sink?.(currentRowNeeds());
}

export function setRowNeedsSink(sink: RowNeedsSink | null): void {
  _sink = sink;
  sink?.(currentRowNeeds());
}
